var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ewebeditor"}},[_c('iframe',{attrs:{"id":_vm.cbid,"src":'/dist/ewebeditor/ewebeditor.htm?style=' + _vm.coolblue + '&id=' + _vm.cidb,"width":"800px","frameborder":"0","scrolling":"no","height":_vm.eheight}})])}
var staticRenderFns = []

export { render, staticRenderFns }